import { render, staticRenderFns } from "./shift-detail-modal.vue?vue&type=template&id=38c386e6&lang=pug"
import script from "./shift-detail-modal.vue?vue&type=script&lang=ts"
export * from "./shift-detail-modal.vue?vue&type=script&lang=ts"
import style0 from "./shift-detail-modal.vue?vue&type=style&index=0&id=38c386e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports